import { setupGlobals } from '../util/GlobalSetup.js';
setupGlobals();

// Expose underscore globally for the few templates that still use it.
global._ = require('underscore');

// Expose ko globally for Knockout view model code.
global.ko = require('knockout');

global.tk = {
  Browse: require('../browse/browse.js'),
  Dialog: require('../tk/dialog.js'),
  FontLoader: require('../tk/font_loader.js'),
  I18n: require('../tk/i18n.js'),
  ImsLib: require('../util/imslib.js')
};

// We can't use the npm version of jquery yet, due to older code that relies on
// deprecated jQuery features.
require('../../../../vendor/assets/javascripts/jquery-1.8.2.js');

require('../tk/ajax_csrf.js');
require('../tk/bindings/bindings.js');
const initBindings = require('../tk/bindings/init_bindings.js');
initBindings();
const globalFontEvents = require('../tk/global_font_events.js');
global.tk.GlobalFontEvents = globalFontEvents;

// Use simple jquery replacement for responsive nav
require('../util/mobile-nav.js');

import('../util/visual_search.js').then(function(visualSearch) {
  visualSearch.init();
});
